export default __webpack_public_path__ + "static/media/csv-icon.d8d0c43c.svg";